import { useEffect } from 'react';
import { Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import { styled } from '@mui/system';

const FlexRadioGroup = styled(RadioGroup)({
  display: 'flex',
  flexDirection: 'row', // Change to 'column' for vertical layout
});

const CustomRadio = ({ options, onLabelSelect ,selectedLabel}: { options: any; onLabelSelect: (label: string) => void ; selectedLabel:any}) => {

  useEffect(() => {
    if (options.length > 0) {
      onLabelSelect(options[0].label);
    }
  }, []);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const label = event.target.value;
    onLabelSelect(label); // Call the callback function to return the selected label
  };

  return (
    <FormControl component="fieldset">
      <FlexRadioGroup
        aria-label="custom-radio"
        name="custom-radio-group"
        value={selectedLabel} // Controlled value for the radio group
        onChange={handleRadioChange}
      >
        {options.map((option: any, index: any) => (
          <FormControlLabel
            key={index}
            value={option.label} // This is the label you want to capture
            control={<Radio />}
            label={option.label} // This is the label that will be displayed
          />
        ))}
      </FlexRadioGroup>
    </FormControl>
  );
};

export default CustomRadio;
